import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';

type TProps = {
  onCancel: () => void;
  title?: string;
  message: string | React.ReactNode;
};

export const GenericErrorModal = ({ onCancel, message, title = 'Error' }: TProps) => (
  <ModalWrapper width="440px">
    <ModalTitle>{title}</ModalTitle>
    <p className="m-0 text-center">{message}</p>
    <div className="mx-auto flex w-[100px]">
      <Button className="min-w-[100px]" type="button" onClick={onCancel}>
        Ok
      </Button>
    </div>
  </ModalWrapper>
);
